<template>
  <section class="app-main">
    <!-- 删除或注释掉这个调试面板 -->
    <!-- <div v-if="$route.meta.showDebug" class="route-debug-info">
      <p>当前路径: {{ $route.path }}</p>
      <p>路由名称: {{ $route.name }}</p>
      <button @click="closeDebugInfo">关闭</button>
    </div> -->
    
    <router-view v-slot="{ Component }">
      <!-- <transition name="fade-transform" mode="out-in"> -->
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      <!-- </transition> -->
    </router-view>
  </section>
</template>

<script>
import { useRoute } from 'vue-router'
import { NET_BASE_URL } from '/src/utils/config';
import { ElMessage } from 'element-plus'
import eventBus from '@/utils/eventBus'
export default {
  name: 'AppMain',
  data() {
    return {
      showDebug: true
    }
  },
  mounted() {
    console.log('AppMain mounted, current route:', this.$route)
    let url = window.location.href
    let urlhead = NET_BASE_URL + "/?"
    if (url.startsWith(urlhead)) {
      ElMessage.warning('页面正在跳转并进行绑定，请勿操作...')
      url = url.replace(NET_BASE_URL + "/", '')
      url = url.replace(this.$route.href, '')
      url = NET_BASE_URL + "/" + this.$route.href + url
      window.location.href = url
    }
  },
  methods: {
    toggleDebug() {
      this.showDebug = !this.showDebug
    }
  },
  watch: {
    $route(to, from) {
      console.log('路由变化:', from.path, '->', to.path)
      console.log('路由名称:', to.name)
      console.log('路由组件:', to.matched[0]?.components?.default)
      console.log('路由匹配:', to.matched.map(m => ({path: m.path, name: m.name})))
      console.log('路由完整信息:', to)
      eventBus.emit(to.path + '-refresh')
    }
  }
}
</script>

<style scoped>
.app-main {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f0f2f5;
}

/* 确保内容区域在小屏幕上也能正确显示 */
@media (max-width: 768px) {
  .app-main {
    padding: 10px;
  }
}

.debug-info {
  margin: 10px;
  padding: 10px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  position: relative;
  z-index: 1000;
}

.debug-toggle {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  padding: 5px 10px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  cursor: pointer;
}

.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style> 